import { TipMovementIcon } from "@/components/TipMovementMarker";
import { MOVEMENT } from "@/utils/tip-movement";

const KEY_ITEMS = [
  [MOVEMENT.UP, "moved up"],
  [MOVEMENT.DOWN, "moved down"],
  [MOVEMENT.NEW, "new"],
  [MOVEMENT.DROPPED, "dropped"],
  [MOVEMENT.SAME, "same"],
  [MOVEMENT.SCRATCHED, "scratched"],
];

/**
 * One-line key for the tip movement markers, under the race tips.
 * Pages show it only while markers are shown (and SHOW_TIP_MARKER_KEY is on).
 */
export default function TipMovementKey() {
  return (
    <div
      className="tip-movement-key flex flex-wrap items-center justify-center gap-x-1.5 gap-y-1 pt-1 pb-2 text-[10px] leading-none text-gray-500"
      data-testid="tip-movement-key"
    >
      <span className="sr-only">Marker key:</span>
      {KEY_ITEMS.map(([status, word]) => (
        <span
          key={status}
          className="inline-flex items-center gap-0.5 whitespace-nowrap"
        >
          <TipMovementIcon status={status} className="w-2.5 h-2.5" />
          {word}
        </span>
      ))}
    </div>
  );
}
